const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Obtener entregas con filtros
export const fetchEntregas = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener entregas');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en fetchEntregas:', error);
    throw error;
  }
};

// Obtener solicitudes pendientes
export const fetchSolicitudesPendientes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/solicitudes-pendientes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener solicitudes pendientes');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en fetchSolicitudesPendientes:', error);
    throw error;
  }
};

// Alistar entrega
export const alistarEntrega = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/alistar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al alistar entrega');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en alistarEntrega:', error);
    throw error;
  }
};

// Marcar como entregado
export const marcarComoEntregado = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/entregar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al marcar como entregado');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en marcarComoEntregado:', error);
    throw error;
  }
};

// Obtener entrega por ID
export const fetchEntregaById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener entrega');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en fetchEntregaById:', error);
    throw error;
  }
};

// Cancelar entrega
export const cancelarEntrega = async (id, usuario, motivo) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/cancelar/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usuario, motivo }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al cancelar entrega');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en cancelarEntrega:', error);
    throw error;
  }
};

// Exportar solicitudes pendientes a Excel
export const exportSolicitudesPendientes = async (filters = {}) => {
  try {
    
    const response = await fetch(`${API_URL}/entregas-lenceria/export/solicitudes-pendientes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al exportar solicitudes pendientes');
    }

    const result = await response.json();    
    // Retornar directamente el array de datos
    return result.data || [];
  } catch (error) {
    console.error('Error en exportSolicitudesPendientes:', error);
    throw error;
  }
};

// Exportar entregas a Excel
export const exportEntregas = async (filters = {}) => {
  try {
    
    const response = await fetch(`${API_URL}/entregas-lenceria/export/entregas`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al exportar entregas');
    }

    const result = await response.json();
    
    // Retornar directamente el array de datos
    return result.data || [];
  } catch (error) {
    console.error('Error en exportEntregas:', error);
    throw error;
  }
};

// Obtener entregas con filtros reportes
export const fetchEntregasReporte = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/entregas-lenceria/filter/entregas-reporte`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener entregas');
    }

    const result = await response.json();
    return result.data || result;
  } catch (error) {
    console.error('Error en fetchEntregas:', error);
    throw error;
  }
};